import { IValuationState } from './types';

export const getValuationValuation = (state: IValuationState) => state.valuation.valuation;
export const getValuationResult = (state: IValuationState) => state.valuation;
